import {mapGetters, mapState} from "vuex";
import {RegionalExplicitEnum} from "@/core/constants/enums/regionalExplicitEnum";

function getPhotoUrl(user, format, size = '', index = 0, withWatermark = false) {
    const photoName = _.get(user, `photos.${index}.name`, _.get(user, `photos_data.${index}.name`, false));
    const hasWatermark = _.get(user, `photos.${index}.has_watermark`, _.get(user, `photos_data.${index}.has_watermark`, false));

    return this.formatPhotoUrl(user.id, photoName ? `${photoName}${withWatermark && hasWatermark ? 'w' : ''}` : false, format, size);
}

function getFirstNonFSKPhotoUrlIfCan(user, format, size) {
    const photo = this.getFirstNonFSKPhotoIfCan(user);

    return this.formatPhotoUrl(user.id, _.get(photo, 'name'), format, size);
}

function getFirstNonFSKPhotoIfCan(user) {
    const photos = _.get(user, 'photos', _.get(user, 'photos_data', []))

    if (photos.length < 1) {
        return null;
    }

    const nonFskPhoto = photos.find(
        photo => !photo.explicit && (!this.userIsFromExplicitRegion || photo.regionalExplicit !== RegionalExplicitEnum.YES),
    )

    return nonFskPhoto || photos[0]
}

function getFirstNonFSKPhotoPhotoSrcSetIfCan(user, format, size = 'medium') {
    return this.getFirstNonFSKPhotoUrlIfCan(user, format, size) + ' 264w, '
        + this.getFirstNonFSKPhotoUrlIfCan(user, format, `${size}/50`) + ' 132w, '
        + this.getFirstNonFSKPhotoUrlIfCan(user, format, `${size}/25`) + ' 66w';
}

function getVideoThumbnailUrl(user, format, size = '', video) {
    return this.formatPhotoUrl(user.id, video.video_id, format, size);
}

function formatPhotoUrl(userId, photoName, format, size = '') {
    if (!photoName) {
        return this.getNoPhotoUrl(size);
    }

    const sizePath = size ? `${size}/` : '';
    const fullUrl = `${constants.user_photo.BASE_URL}${userId}/${sizePath}${photoName}.${format}`;

    return this.handleFallbackProductionImageUrl(fullUrl, `erobella-images/images/photos/${userId}/${sizePath}`);
}

function getPhotoObject(user, index = 0) {
    return _.get(user, `photos.${index}`, _.get(user, `photos_data.${index}`, false));
}

/** @deprecated use instead photoMixin.formatPhotoUrl */
function getPhotoUrlByName(name, model_id, format, size = '') {
    return this.formatPhotoUrl(model_id, name, format, size);
}

function getPhotoSrcSet(user, format, index = 0, size = 'medium') {
    return this.getPhotoUrl(user, format, size, index) + ' 264w, '
        + this.getPhotoUrl(user, format, `${size}/50`, index) + ' 132w, '
        + this.getPhotoUrl(user, format, `${size}/25`, index) + ' 66w';
}

function getNoPhotoUrl(size) {
    return size === 'small'
        ? constants.user_photo.NO_PHOTO_SEARCH_URL_SMALL
        : constants.user_photo.NO_PHOTO_SEARCH_URL;
}

function getProfileBannerUrl(user, format = 'jpg') {
    if (!user.profileBanner) {
        return false;
    }

    return constants.user_photo.PROFILE_BANNER_URL + user.id + '/' + user.profileBanner.name + '.' + format;
}

function getPrivatePhotoUrl(photo, size = 'default', format = 'jpg') {
    return photo.urls[size][format];
}

function handleFallbackProductionImageUrl(imageUrl, cdnPath) {
    if (!imageUrl || !imageUrl.includes('_preprod')) {
        return imageUrl;
    }

    const cleanedUrl = imageUrl.replace('_preprod', '');
    const urlParts = cleanedUrl.split('/');
    const imageFilename = urlParts[urlParts.length - 1];

    return `${this.getCdnProductionUrl}/${cdnPath}${imageFilename}`;
}

export default {
    methods: {
        getPhotoUrl,
        getVideoThumbnailUrl,
        getPhotoUrlByName,
        getPhotoSrcSet,
        getNoPhotoUrl,
        getPhotoObject,
        getProfileBannerUrl,
        getPrivatePhotoUrl,
        formatPhotoUrl,
        handleFallbackProductionImageUrl,
        getFirstNonFSKPhotoUrlIfCan,
        getFirstNonFSKPhotoIfCan,
        getFirstNonFSKPhotoPhotoSrcSetIfCan,
    },
    computed: {
        ...mapGetters(['getCdnProductionUrl']),
        ...mapState(['userIsFromExplicitRegion']),
    },
}
